import { ArrowForwardIcon, InfoOutlineIcon } from "@chakra-ui/icons";
import { Box, Button, Center, Flex, Text } from "@chakra-ui/react";
import {
  ModalUpdateChanges,
  openModalUpdateChanges
} from "components/servicos-components/user-licences/modal-update-changes";

export function AvisosUpdate() {
  return (
    <Flex
      bg="#fff"
      borderLeft="4px solid var(--chakra-colors-primary-400)"
      alignItems="center"
      justifyContent="space-between"
      p="16px"
      mb="30px"
      borderRadius="10px"
      w="100%"
    >
      <ModalUpdateChanges></ModalUpdateChanges>
      <Flex alignItems="center" gap="16px">
        <Center
          w="40px"
          h="40px"
          bg="#D9E6F5"
          borderRadius="full"
          flexShrink={0}
        >
          <InfoOutlineIcon w="20px" h="20px" color="#1C2B3F" />
        </Center>
        <Flex alignItems="center" gap="8px" flexWrap="wrap">
          <Text color="#1C2B3F" fontWeight="bold" fontSize="16px">
            Atualização de Crédito PowerHub
          </Text>
          <Box w="4px" h="4px" bg="#A1A9B2" borderRadius="full" />
          <Text color="#3E4C59" fontSize="16px" whiteSpace="pre-wrap">
            Os valores de telefonia e SMS foram reduzidos para oferecer ainda
            mais economia na sua operação. Para mais detalhes sobre as
            atualizações, clique no botão ao lado.
          </Text>
        </Flex>
      </Flex>

      <Flex alignItems="center" gap="16px" ml="10px">
        <Button
          rightIcon={<ArrowForwardIcon />}
          // onClick={() => router.push("/mudancas-update")}
          onClick={() => openModalUpdateChanges()}
        >
          Ver mudanças
        </Button>
      </Flex>
    </Flex>
  );
}
